export class XmlInfoDto {
  private _xmlContent: string
  private _md5Hash: string
  private _batchId: string

  constructor (md5Hash: string, batchId: string, xmlContent: string) {
    this._xmlContent = xmlContent
    this._batchId = batchId
    this._md5Hash = md5Hash
  }

  get md5Hash (): string {
    return this._md5Hash
  }

  get batchId (): string {
    return this._batchId
  }

  get xmlContent (): string {
    return this._xmlContent
  }
}
